import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentRef
} from '@angular/core';

import { FormGroup } from '@angular/forms';

import { RendererRegistryService } from '../registry/renderer-registry.service';

@Component({
  selector: 'app-field-host',
  standalone: true,
  template: `<ng-template #container></ng-template>`
})
export class FieldHostComponent implements OnInit {
  
  @Input() field!: any;
  @Input() form!: FormGroup;
  @Input() row?: FormGroup;

  @ViewChild('container', {
    read: ViewContainerRef,
    static: true
  })
  container!: ViewContainerRef;

  constructor(
    private registry: RendererRegistryService
  ) {}

  ngOnInit(): void {

    const key =
      this.field.renderer ||
      this.field.type;

    const component =
      this.registry.resolve(key);

    if (!component) {
      console.error(
        `Renderer not found: ${key}`
      );
      return;
    }

    this.container.clear();

    const ref: ComponentRef<any> =
      this.container.createComponent(component);

    ref.instance.context = {
      field: this.field,
      form: this.form,
      row: this.row
    };
  }
}